<breadcrumbs class="block wrap m-t-3 m-t-4-s m-t-4-m" />
<div class="wrap center flex-column flex-middle p-b-0-s m-t-10">
    @if (topCopy) {
    <p class="o1 col-1"
       [innerHTML]="topCopy"></p>
    }
    @if (name) {
    <h1 class="h1 col-1 m-t-2">{{name}}</h1>
    }

    @if(bottomCopy) {
    <p class="p1 col-1 m-t-2"
       [style.maxWidth.px]="client.sizeId > 1 ? 1122 : 343"
       [innerHTML]="bottomCopy"></p>
    }
</div>



<!-- tag filter -->
@if (navigationItems?.length) {
<ul class="m-t-10 pos-relative center wrap">
    @if (client.sizeId > 1) {
    <!-- desktop -->
    @for (option of navigationItems; track $index;) {
    <ng-container *ngTemplateOutlet="navOptionTmpl; context: { $implicit: option, first : $first}" />
    }
    }
    @else{
    <!-- mobile--->
    <div class="block pos-relative">
        <dropdown2 (valueChange)="selectNav($event)"
                   [options]="navigationItems"
                   (openChange)="openChangeHandler($event)"
                   class="left">
            <ng-template #titleTpl>
                {{currentCategoryName}}
            </ng-template>
            <ng-template #optionTpl
                         let-option>
                <ng-container *ngTemplateOutlet="navOptionTmpl; context: { $implicit: option}" />
            </ng-template>
        </dropdown2>
    </div>
    }
</ul>
}


<div class="pos-relative">
    @if(isNavOpen()){
    <div class="_overlay bg-col-1 pos-absolute z-1"
         style="inset: 0; opacity: 0.25"></div>
    }
    <div class="bg-col-w p-t-10 p-t-5-s p-t-5-m p-b-10 m-t-10">
        <!-- listing -->
        <div class="wrap">
            <!-- empty listing message -->
            @if (listing.ready && !listing.models?.length) {
            <p class="s1 center">{{'There are no articles in this category yet.' | translate}}</p>
            }

            <div [grid]="[1, 2, 4, 4][client.sizeId]"
                 [gridColumnGap]="'12px'"
                 [gridRowGap]="client.sizeId > 1 ? '24px' : '16px' ">
                @for (model of listing.models; track model.id;) {
                <cms-blog-content-blog-card [model]="model"
                                            class="bg-col-w block" />
                }
            </div>
        </div>

        <!-- show more button -->
        @if (listing.hasMore) {
        <div class="center m-t-15">
            <button [buttonStyle]="'button-1'"
                    (click)="listing.increaseLimit()"
                    [attr.aria-label]="'View more' | translate"
                    type="button">
                {{'View more' | translate}}
            </button>
        </div>
        }
    </div>
</div>


<!-- option template with switching between href and filter option
optHref was causing errors here -->
<ng-template let-option
             let-first="first"
             #navOptionTmpl>
    <!-- links for tag-redirect mode -->
    @if (typeData?.tagRedirect) {
    <a [routerLink]="option.url">
        <ng-container *ngTemplateOutlet="navOptionInnerTmpl; context: { $implicit: option, first : first}" />
    </a>
    }
    <!-- simple filter output for non redirect case -->
    @else{
    <ng-container *ngTemplateOutlet="navOptionInnerTmpl; context: { $implicit: option, first : first}" />
    }
</ng-template>

<!-- inner template with list item -->
<ng-template let-option
             let-first="first"
             #navOptionInnerTmpl>
    @if (client.sizeId > 1) {
    <button type="button"
            class="s1 col-1 p-a p-t-2 p-b-2 m-b-3"
            style="border-radius: 20px;"
            [ngClass]="[ isSelected(option) ? 'bg-col-6' : 'b-a b-col-1', first ? '' : 'm-l-4-x m-l-4-l' ]"
            (click)="selectNav(option)">
        {{option.name}}
    </button>
    } @else {
    <button type="button"
            class="p2 col-1"
            (click)="selectNav(option)">
        {{option.name}}
    </button>
    }
</ng-template>